import { takeEvery } from 'redux-saga/effects';
import { emailMarketing } from './email-marketing';

export function* emailMarketingSaga() {
  yield takeEvery(['EMAIL_MARKETING'], emailMarketing);
}
